<!-- 病虫害列表面板 -->
<template>
  <div style="color: #fff; display: flex">
    <!-- 前5个当前阶段重点防范的病虫害 -->
    <div
      v-for="it in first5"
      :key="it.code"
      style="flex-grow: 1; padding: 0 5px; width: 300px"
    >
      <item :profile="it">
        {{ it }}
      </item>
    </div>
    <!-- 最后一个面板显示“更多” -->
    <div style="flex-grow: 1; padding: 0 5px; width: 180px">
      <div style="font-size: 13px; height: 24px; padding-top: 3px">
        更多病虫害
      </div>
      <div
        v-for="mo in more"
        :key="mo.code"
        style="
          line-height: 60px;
          background-color: #937376;
          margin-bottom: 10px;
          border-radius: 10px;
          padding: 10px 20px;
          color: #dfc3c9;
          font-size: 12px;
        "
      >
        {{ mo.name }}
      </div>
    </div>
  </div>
</template>
<script>
import Item from './item.vue'
export default {
  components: { Item },
  data() {
    return {
      items: [
        {
          name: '炭疽病',
          code: 101,
          val: 86,
          picture: 'tanqu.png',
          desc: '草莓炭疽病是由胶孢炭疽菌、尖孢炭疽菌或草莓炭疽菌侵染所引起的病害。侵染草莓叶部有2种炭疽病菌：一种是炭疽叶斑病，也叫黑斑病，由草莓炭疽菌和胶孢炭疽菌引起；另一种是不规则叶斑病，由尖孢炭疽菌引起。草莓炭疽病主要发生在草莓的叶片、叶柄、匍匐茎、根茎、花和果实上。',
        },
        {
          name: '白粉病',
          code: 104,
          val: 85,
          desc: '草莓白粉病是由羽衣草单囊壳侵染所引起的、发生在草莓上的一种病害。主要危害叶片、叶柄、花器、果实、果柄。发病后叶背面出现白色丝状菌丝，后形成白粉；发病后期叶片褪绿、黄化，其表面覆盖着白色霉层。',
        },
        {
          name: '叶斑病',
          code: 105,
          val: 48,
          picture: 'yeban.png',
          desc: '草莓细菌性叶斑病是一种主要寄生在浆果类、十字花科、葫芦科、豆科、茄科等植物上的一种细菌，主要危害植物叶片、果柄、花萼、茎等部位使其干缩破碎，严重时使植株生长点变黑枯死。',
        },
        {
          name: '根腐病',
          code: 102,
          val: 29,
          picture: 'genfu.png',
          desc: '草莓根腐病主要为害根部。急性型根腐多在春夏两季发生（苗床时期）雨后叶尖突然萎凋，不久呈青枯状，引起全株迅速枯死。慢性型定植后至冬初均可发生，下部老叶叶缘变紫红色或紫褐色，逐渐向上扩展，全株萎蔫或枯死。检视根部可见根系变褐腐朽。',
        },
        {
          name: '灰霉病',
          code: 103,
          val: 24,
          picture: 'huimei.png',
          desc: '草莓灰霉病是由灰葡萄孢菌侵染所引起的、发生在草莓上的病害。主要危害草莓花器、果实、叶柄和叶片，不同部位表现症状不尽相同。叶片受害症状在发病初期老叶形成“V”字形黄褐色病斑，随着病害加重，叶片焦枯死亡。',
        },
        {
          name: '红蜘蛛',
          code: 201,
          val: 76,
          picture: 'hongzhizhu.png',
          desc: '',
        },
        {
          name: '叶螨',
          code: 202,
          val: 43,
          desc: '',
        },
        {
          name: '蓟马',
          code: 203,
          val: 23,
          desc: '',
        },
        {
          name: '蚜虫',
          code: 204,
          val: 13,
          desc: '',
        },
        {
          name: '白粉虱',
          code: 205,
          val: 18,
          desc: '',
        },
      ],
    }
  },
  computed: {
    first5() {
      return this.items.slice(0, 5)
    },
    more() {
      return this.items.slice(6)
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/disease/list/index.vue